import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/stores/:storeId/read-status/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const readStatus = {
  get: apiPathFunc(pathBase),
};
